module.exports = __webpack_public_path__ + "static/media/Books.5cdb9be0.jpg";